module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    orange: '#FF6A3D',
                    red: '#DC1720',
                    yellow: '#FBBF24',
                    lighterblack: '#1E1E20',
                    lightergray: '#616161',
                    customgray: '#F8F8FB',
                },
            },
        },
        fontFamily: {
            outfit: ['Outfit', 'sans-serif'],
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
